/**
 * Method to allow easily concatente property listings into meaningful test ID's
 * @param inputString string
 * @returns concatenated string
 */
export const concatenateAndReplace = (inputString: string) => {
  let trimmedString = inputString.trim();
  let replacedString = trimmedString.replace(/[\s,]+/g, '-').toLowerCase();
  let result = replacedString.substring(0, 35);
  return result;
};

export const extractNameFromHref = (href: string): string | null => {
  const regex = /\/listings\/([^\/]+)---[^\/]+\/?/;
  const match = href.match(regex);

  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
};
